import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  measurementUnitsLength: 0,
  measurementUnits: [],
  measurementUnit: {},
  measurementUnitError: "",
  formError: "",
};

export default function MeasurementUnitReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_MEASUREMENT_UNIT:
      return { ...state, loading: action.payload };
    case actions.LOADING_MEASUREMENT_UNIT_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_MEASUREMENT_UNIT:
      return { ...state, saveLoading: action.payload };
    case actions.GET_MEASUREMENT_UNIT:
      return {
        ...state,
        measurementUnits: action.payload.measurementUnits,
        measurementUnitsLength: action.payload.measurementUnitsLength,
      };
    case actions.GET_MEASUREMENT_UNIT_BY_ID:
      return {
        ...state, measurementUnit: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.MEASUREMENT_UNIT_FAIL:
      return { ...state, measurementUnitError: action.payload };
    default:
      return state;
  }
}
